import React, { useEffect, useMemo, useState } from 'react';
import ReactModal from 'react-modal';
import CommonProductList from './CommonProductList';
import FeaturedProducts from './FeaturedProducts/FeaturedProducts';
import { connect } from 'react-redux';
import {
    accountFormIsVisible,
    pageLoading,
    pagesSubtitleSelector,
    sessionKey,
    pagesTariffsByProductSelector,
} from '../redux/selectors/pagesSelectors';
import { checkKey, setAccountFormIsVisible, setPageSubtitle } from '../redux/actions/pagesActions';
import { FEATURED_PRODUCTS_PAIR } from '../constants/constants';
import RegisterForm from './Registraion/RegisterForm';
import {
    cartAccountSelector,
    cartAutoUpgradeSelector,
    cartCartSelector,
    cartFeaturedIdsFromQuerySelector,
    cartFeaturedProductsListSelector,
    cartFlagsApplied,
    cartMainProduct,
    cartCurrencySelector,
} from '../redux/selectors/cartSelector';
import AlertStatic from './General/AlertStatic';
import getProductTitle from '../resolvers/getProductTitle';
import {
    setAppliedFlags,
    setAutoUpgrade,
    setFeaturedFromQuery,
    setRenew,
} from '../redux/actions/cartAction';
import useTotal from '../hooks/useTotal';
import useTotalSum from '../hooks/useTotalSum';
import isRenewAllowedByPeriod from '../resolvers/isRenewAllowedByPeriod';
import { newFiltersPeriodByTariffSelector } from '../redux/selectors/filtersSelector';
import Cards_old from './Cards_old';
import Cards from './Cards';
import Skeleton from 'react-loading-skeleton';
import Select, { components } from 'react-select';
import { getPromoFromArray } from '../utils';

function MainContainer({
    checkKey,
    mainProduct,
    featuredProductsList,
    setFormIsVisible,
    registrationFormIsVisible,
    setFeatured,
    featuredProductsFromQuery,
    appliedFlags,
    setAppliedFlags,
    sessionKey,
    account,
    periodsList,
    cart,
    setCartRenew,
    cartAutoUpgrade,
    setAutoUpgrade,
    currency,
    pageSubtitle,
    setPageSubtitle,
    promoCodesList,
    tariffListByProduct,
    pageLoading,
}) {
    const total = useTotal();
    const totalSum = useTotalSum(mainProduct?.product_id);

    const [showError, setShowError] = useState(false);

    useEffect(() => {
        checkKey();
    }, []);

    const title = useMemo(() => getProductTitle(mainProduct), [mainProduct]);

    useEffect(() => {
        setPageSubtitle('');
    }, [mainProduct?.product_id]);

    useEffect(() => {
        if (!mainProduct?.product_id) {
            return;
        }
        // The next logic is responsible for auto selecting the featured product
        // on "cold" start (when no &featured= products in a parameter were supplied).
        // - featuredAutoSelect - identifies either user opened page w/o featured products specified
        // - featuredAutoSelectProduct - shows if featured products auto-selection was applied
        //   to a main product (so it works as a default action, but won't be re-applied
        //   when user re-visits the same main product).
        let featuredAutoSelect = !!appliedFlags.featuredAutoSelect;
        if (!featuredAutoSelect && featuredProductsFromQuery === '*') {
            featuredAutoSelect = true;
            setAppliedFlags({
                flags: { featuredAutoSelect },
            });
        }
        if (
            featuredAutoSelect &&
            !appliedFlags?.featuredAutoSelectProduct[mainProduct?.product_id]
        ) {
            setFeatured({
                featured: FEATURED_PRODUCTS_PAIR[mainProduct?.product_id]?.products ?? [],
            });
            setAppliedFlags({
                flags: {
                    featuredAutoSelectProduct: {
                        [mainProduct?.product_id]: true,
                    },
                },
            });
        }
    }, [featuredProductsFromQuery, mainProduct]);

    const handleRenewChange = (val) => {
        setCartRenew({ renew: val });
    };

    const isRenewableState = () => {
        if ([2, 7].includes(mainProduct?.product_id)) {
            return true;
        }
        const period = mainProduct?.period ?? cart?.period;
        return period ? isRenewAllowedByPeriod(period) : true;
    };

    const handleAutoUpgradeChange = (value) => {
        setAutoUpgrade({ value });
    };

    const calculateFinalCost = (cost, intervalCount, intervalDiscount) => {
        const discountMultiplier = (100 - intervalDiscount) / 100;
        return cost * intervalCount * discountMultiplier;
    };

    useEffect(() => {
        const tariffCurrent = Object.values(tariffListByProduct).filter(
            (tariff) => tariff.tariff_id === mainProduct?.current_tariff_id
        );

        if (tariffCurrent && tariffCurrent[0]) {
            const filteredTariffs = Object.values(tariffListByProduct).filter(
                (tariff) => tariff.product_id === mainProduct?.product_id
            );

            let max = 0;

            filteredTariffs.forEach((tariff) => {
                Object.values(tariff.periods).forEach((period) => {
                    const finalCost = calculateFinalCost(
                        tariff.cost,
                        period.interval_count,
                        period.interval_discount
                    );

                    if (finalCost > max) {
                        max = finalCost;
                    }
                });
            });
            if (max < mainProduct?.discount_amount) {
                setShowError(true);
            } else {
                setShowError(false);
            }
        } else {
            setShowError(false);
        }
    }, [
        mainProduct?.product_id,
        mainProduct?.discount_amount,
        mainProduct?.current_tariff_id,
        tariffListByProduct,
    ]);

    return (
        <div className="container">
            <>
                <h1 className={'title-1 text--center mb-8 tablet-ml-16 tablet-mr-16'}>
                    {pageLoading ? <Skeleton width={300} /> : title}
                </h1>

                {showError ? (
                    <div className={'notification__message mb-60 mt-0'}>
                        Your discount exceeds the maximum license cost. Please contact{' '}
                        <a className={'header__link'} href="https://cleantalk.org/my/support">
                            support
                        </a>
                    </div>
                ) : (
                    <>
                        <div className={'subtitle mb-36 tablet-mb-16 text--center'}>
                            {pageSubtitle}
                        </div>
                        <CommonProductList />
                        <div className={'flex flex--end section'}>
                            <div className={'section__cell checkbox-list'}>
                                {pageLoading && <Skeleton height={115} className={'mb-13'} />}
                                {periodsList &&
                                    // - Renew for SSL (5) is not supported on backend side
                                    // - Renew for doBoard (7) and DB API can be renewed on any period (months).
                                    mainProduct?.product_id !== 5 &&
                                    (mainProduct?.product_id === 2 ||
                                        mainProduct?.product_id === 7 ||
                                        !!Object.values(periodsList)?.filter(
                                            // Not clear the initial intention of the condition there,
                                            // based on "reverse-analysis" it looks like it should work like:
                                            // "if there is at least one "1 year" period among available - allow a renewal switcher".
                                            // Also is not allowed renewal for SSL products.
                                            (period) => isRenewAllowedByPeriod(period)
                                        ).length) && (
                                        <div className="checkbox">
                                            <input
                                                type="checkbox"
                                                id={`renew-${mainProduct?.product_id}`}
                                                className="checkbox__input"
                                                disabled={!isRenewableState()}
                                                checked={isRenewableState() && cart?.renew}
                                                onChange={(e) =>
                                                    handleRenewChange(e.target.checked)
                                                }
                                            />

                                            <label
                                                htmlFor={`renew-${mainProduct?.product_id}`}
                                                className={'checkbox__label text-3'}
                                            >
                                                Automatically renew {mainProduct?.product_name}{' '}
                                                license
                                            </label>
                                            <div
                                                className={
                                                    'checkbox__note text-4 pt-2 color--gray flex flex--column'
                                                }
                                            >
                                                <span>
                                                    Auto-renewal is available only for periods less
                                                    than one year.
                                                </span>
                                                <i className={'mt-10'}>
                                                    Currency rate is estimated and provided by{' '}
                                                    <a
                                                        className={'color--gray'}
                                                        href="http://finance.yahoo.com/currency-converter/"
                                                        target="_blank"
                                                    >
                                                        Yahoo finance
                                                    </a>
                                                    , it may be different compared to a payment
                                                    provider.
                                                </i>
                                            </div>
                                        </div>
                                    )}

                                {mainProduct?.product_id === 2 /* black list DB API */ && (
                                    <div className="checkbox">
                                        <input
                                            type="checkbox"
                                            id={`auto-upgrade-${mainProduct?.product_id}`}
                                            className="checkbox__input"
                                            disabled={!isRenewableState()}
                                            checked={cartAutoUpgrade}
                                            onChange={(e) =>
                                                handleAutoUpgradeChange(e.target.checked)
                                            }
                                        />

                                        <label
                                            htmlFor={`auto-upgrade-${mainProduct?.product_id}`}
                                            className={'checkbox__label text-3'}
                                        >
                                            Auto upgrade of the tariff when the limit is exceeded
                                        </label>
                                    </div>
                                )}
                            </div>
                        </div>
                        {currency?.currency && currency?.currency === 'RUB' && (
                            <div className={'notification__message'}>
                                <p>
                                    Если у вас возникли проблемы с оплатой в рублях, то
                                    воспользуйтесь сервисом{' '}
                                    <a href="https://cleantalk-shop.ru" target="_blank">cleantalk-shop.ru</a> или{' '}
                                    <a href="https://pay-saas.ru" target="_blank">pay-saas.ru</a>.
                                </p>
                            </div>
                        )}

                        {/* If tariff is selected & is not a subscribable */}
                        {mainProduct?.tariff && !mainProduct?.tariff?.allow_subscribe && (
                            <AlertStatic
                                alertType="warning"
                                message="You are using old package that has been de-listed from our price list. But you can renew the package or choose one of packages from current price list."
                            />
                        )}
                        {(mainProduct?.product_id === 7 && sessionKey && !account && (
                            <AlertStatic
                                alertType="info"
                                message="There is no associated doBoard account with your profile. You can create a free doBoard account "
                                link={{ href: 'https://doboard.com/signup', title: 'now' }}
                            />
                        )) || (
                            <><Cards setAccountFormIsVisible={setFormIsVisible} /></>
                        )}
                    </>
                )}

                <ReactModal
                    isOpen={registrationFormIsVisible}
                    contentLabel="onRequestClose Example"
                    onRequestClose={() => setFormIsVisible(false)}
                    shouldCloseOnOverlayClick={false}
                    portalClassName={'modal__container'}
                    overlayClassName={'modal__overlay'}
                    className={'modal__content'}
                    bodyOpenClassName={'body--modal-opened'}
                    htmlOpenClassName={'html--modal-opened'}
                    ariaHideApp={false}
                    closeTimeoutMS={500}
                >
                    <RegisterForm />
                </ReactModal>
            </>
        </div>
    );
}

const mapStateToProps = (state, props) => ({
    account: cartAccountSelector(state),
    featuredProductsFromQuery: cartFeaturedIdsFromQuerySelector(state),
    sessionKey: sessionKey(state),
    mainProduct: cartMainProduct(state),
    featuredProductsList: cartFeaturedProductsListSelector(state),
    registrationFormIsVisible: accountFormIsVisible(state),
    appliedFlags: cartFlagsApplied(state),
    periodsList: newFiltersPeriodByTariffSelector(state, props),
    cart: cartCartSelector(state),
    cartAutoUpgrade: cartAutoUpgradeSelector(state),
    currency: cartCurrencySelector(state),
    pageSubtitle: pagesSubtitleSelector(state),
    tariffListByProduct: pagesTariffsByProductSelector(state),
    pageLoading: pageLoading(state),
});

const mapDispatchToProps = (dispatch) => ({
    checkKey: (data) => dispatch(checkKey(data)),
    setFormIsVisible: (flag) => dispatch(setAccountFormIsVisible(flag)),
    setFeatured: (data) => dispatch(setFeaturedFromQuery(data)),
    setAppliedFlags: (data) => dispatch(setAppliedFlags(data)),
    setCartRenew: (data) => dispatch(setRenew(data)),
    setAutoUpgrade: (value) => dispatch(setAutoUpgrade(value)),
    setPageSubtitle: (value) => dispatch(setPageSubtitle(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainContainer);
